import { useState } from 'react'
import { FullScreenModal } from '../../utility/FullScreenModal'
import { SystemSS } from '../../components/SystemSS'

export const Confriend = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalContent, setModalContent] = useState({ contentType: '', category: '', index: 1 })
    const handleOpenModal = (contentType, category, index, maxIndex) => {
        setModalContent({ contentType, category, index, maxIndex })
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setShowModal(false)
    }
    return (
        <>
            <div className='flex justify-center '>
                <img
                    className=''
                    alt='confriend'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-confriend-fr.png`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sub md:text-base text-shadow-white w-full md:w-4/5 px-4 md:px-0 mx-auto mt-12'>
                <p>
                    Marona possède <span className='text-pborange'>un pouvoir spécial</span> qui lui permet de combiner
                    ses alliés fantômes en elle... le «<span className='text-pborange'> Fantôcombinage</span> » ! Il
                    vous permettra d'<span className='text-pborange'>augmenter vos statistiques</span> grâce aux{' '}
                    <span className='text-pborange'>alliés avec lesquels vous possédez des liens forts</span> !
                </p>
                <p className='mt-4'>À vous d'en profiter pour renverser les situations les plus désespérées.</p>{' '}
                <div className='flex mt-8'>
                    <div className='flex flex-col md:flex-row gap-4 mt-8'>
                        <div className='w-full md:w-1/2'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'confriend', 1)
                                }}
                                className='ss-thumb'
                                alt='screen shot of game system'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-confriend-1-s.webp`}
                            />
                        </div>
                        <div className='w-full md:w-1/2'>
                            <img
                                onClick={() => {
                                    handleOpenModal('image', 'confriend', 2)
                                }}
                                className='ss-thumb'
                                alt='screen shot of game system'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-confriend-2-s.webp`}
                            />{' '}
                        </div>{' '}
                    </div>{' '}
                </div>{' '}
            </div>{' '}
            <div className='flex justify-center mt-12'>
                <img
                    className=''
                    alt='screen shot of game scene'
                    src={`${process.env.PUBLIC_URL}/images/system/system-header-onemore-fr.png`}
                />
            </div>{' '}
            <div className='text-pbnavy font-kiwi font-bold text-sm md:text-base text-shadow-white w-4/5 md:w-3/5 mx-auto mt-12'>
                <p>
                    Si certaines conditions sont réunies quand Marona utilise Fantôcombinage pour combiner des fantômes
                    avec elle, <span className='text-pborange'>Encore</span> s'active pour lui accorder{' '}
                    <span className='text-pborange'>plus d'actions</span> ! Marona a ainsi la possibilité d'effectuer
                    plus d'actions et d'augmenter temporairement ses statistiques.
                </p>
                <p className='mt-4'>
                    Plus le lien qui unit Marona et le personnage avec lequel elle s'est fantôcombinée est solide, plus
                    elle activera d'Encores, ce qui augmentera davantage encore les statistiques ! Il est même possible
                    d'éliminer l'ennemi d'un seul coup en enchaînant plusieurs Encores !
                </p>{' '}
                <SystemSS
                    mediaItems={[
                        {
                            modalId: 'confriend',
                            index: 3,
                        },
                    ]}
                    handleOpenModal={handleOpenModal}
                    description="Quoi de plus jouissif que d'éliminer tous ces ennemis ?"
                />
                {/* <div className='flex mt-8'>
                    <div className='w-full md:w-3/5 mx-auto'>
                        <img
                            onClick={() => {
                                handleOpenModal(3)
                            }}
                            className='ss-thumb'
                            alt='screen shot of game scene'
                            src={`${process.env.PUBLIC_URL}/images/ss/ss-confriend-3-s.webp`}
                        />
                        <p className='mt-4 text-pbnavy font-kiwi font-bold text-sub md:text-sm text-shadow-white text-center'>
                            Quoi de plus jouissif que d'éliminer tous ces ennemis ?
                        </p>
                    </div>
                </div>{' '} */}
                <FullScreenModal
                    showModal={showModal}
                    modalContent={modalContent}
                    setModalImage
                    handleCloseModal={handleCloseModal}
                    setModalContent={setModalContent}
                    maxIndex={3}
                />{' '}
            </div>{' '}
        </>
    )
}
